module.exports = __webpack_public_path__ + "static/pattern-contact-729d2206489c3f3a63cfd94f5ea07a53.jpg";